import type { InteractionMetrics } from '../../common';

export const interactions: Map<string, InteractionMetrics> = new Map();
